"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));
const StepLogo = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingBottom: theme.spacing(2)
}));
const StepTitle = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingBottom: theme.spacing(4)
}));
const StepSubTitle = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingBottom: theme.spacing(3)
}));
const Stepper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  paddingBottom: theme.spacing(6)
}));
const StepContent = (0, _mui.styled)('div')(({
  theme
}) => ({
  paddingBottom: theme.spacing(6)
}));
const SkeletonText = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: '163px',
  height: '5px',
  margin: theme.spacing(0, 1)
}));
const StepSkeleton = () => {
  const theme = (0, _mui.useTheme)();
  const isMobile = (0, _mui.useMediaQuery)(theme.breakpoints.down('sm'));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Root, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Stepper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        variant: "circular",
        width: 40,
        height: 40,
        sx: {
          borderRadius: 10
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonText, {
        variant: "text"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        variant: "circular",
        width: 40,
        height: 40,
        sx: {
          borderRadius: 10
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SkeletonText, {
        variant: "text"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        variant: "circular",
        width: 40,
        height: 40,
        sx: {
          borderRadius: 10
        }
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StepLogo, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        height: 56,
        width: isMobile ? 253 : 273,
        variant: "rectangular"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StepTitle, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        height: 33,
        width: isMobile ? 300 : 352,
        variant: "rectangular"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StepSubTitle, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        height: 73,
        width: isMobile ? 320 : 542,
        variant: "rectangular"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StepContent, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
        height: 178,
        width: isMobile ? 320 : 542,
        variant: "rectangular"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Skeleton, {
      height: 56,
      width: isMobile ? 290 : 347,
      variant: "rectangular"
    })]
  });
};
exports.StepSkeleton = StepSkeleton;